import { Component, OnInit, Optional } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { NbDialogRef, NbMenuItem, NbMenuService } from '@nebular/theme';
import { PreviewEditStoreService } from '../../../../../services/preview-edit-store.service';
import { GridCell, GridCellElement, RendererType, ContentStatusEnum, Section, GridCellClass, ContentElement, GridLayoutEnum, ContentEnum, ContentElementEnum } from '@urbannex/storethemes';
import { BehaviorSubject, Subject } from 'rxjs';
import { EditorTemplateService } from '../../../../editor-template.service';
import { SectionBuilderStoreService } from '../../../../sections-editor/shared-section-builder/section-builder-store.service';
import { MenuItemPlaceHolder } from '../../home-input-grid/grid-input-dialog/grid-input-dialog.component';
import { MenuItemContext } from '../../../../../editor-container/editor-model';
import { EditState } from '../../../../../model';


@Component({
  selector: 'ngx-banner-input-dialog',
  templateUrl: './banner-input-dialog.component.html',
  styleUrls: ['./banner-input-dialog.component.scss']
})
export class BannerInputDialogComponent implements OnInit{
  title:string;
  layoutClass:string;
  contentType:any;
  selectedCell:GridCell;
  cellElements:GridCellElement<any>[] = [];
  rendererType = RendererType.BANNER;

  menuItemPlaceHolders:MenuItemPlaceHolder[] = [];

  section:Section;

  status:ContentStatusEnum;

  status$ = new BehaviorSubject(null);

  gridCells:GridCell[] = [];

  screenSize = "default"

  menuItems:NbMenuItem[] = [
    {
      title:"Cells",
      group:true
    }
  ];

  hasLoaded = false;
  private destroy$ = new Subject<void>();

  canSave = false;

  svgData = `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200">
                   <rect width="200" height="200" fill="#cccccc" />
                   <text x="50%" y="50%" font-size="20" text-anchor="middle" fill="#777777" dy=".3em">Placeholder</text>
                 </svg>`;
  encodedSvg = encodeURIComponent(this.svgData);

  svgUrl = `data:image/svg+xml,${this.encodedSvg}`;

  svgBackground: SafeStyle;

  constructor(
    @Optional() protected ref: NbDialogRef<BannerInputDialogComponent>,
    private editorTemplateService:EditorTemplateService,
    private sanitizer: DomSanitizer,
    private sectionBuilderStoreService:SectionBuilderStoreService,
    private menuService:NbMenuService,
    private previewEditStoreService:PreviewEditStoreService) { }
  
   ngOnInit(): void {
    //this.createGridCells(this.layoutClass);
    this.svgBackground = this.sanitizer.bypassSecurityTrustStyle(`url("${this.svgUrl}")`);
    this.createSection(this.layoutClass);
    /* this.section$.pipe(takeUntil(this.destroy$)).subscribe(section => {
      console.log(section);
        this.section = section
    }); */
    this.sectionBuilderStoreService.section$.subscribe(section => {
      if(section != undefined){
        console.log(section);
        this.section = section;
        if(this.section.status != undefined) {
          this.status$.next(this.section.status);
        }else{
          this.status$.next(ContentStatusEnum.CTNT_IN_PROGRESS);
        }
      }
      
    })
  }

  createSection(layoutClass:string){
    let templateContentId;
    
    let gridCells = [];
    switch (layoutClass) {
      case "layout-class-1":
        templateContentId = "BAN_1_CNT";
        //this.section.title = null;
        break;
      case "layout-class-1":
        templateContentId = "BAN_2_CNT";
        //this.section.title = null;
        break;
      case "layout-class-1":
        templateContentId = "BAN_3_CNT";
        //gridCells = this.createGridCells("grid-5");
        //this.section.title = null;
        break;
      case "layout-class-1":
        templateContentId = "BAN_4_CNT";
        //gridCells = this.createGridCells("grid-6");
        //this.section.title = null;
        break;
      case "layout-class-1":
        templateContentId = "BAN_5_CNT";
        //gridCells = this.createGridCells("grid-7");
        break;
      case "layout-class-1":
        templateContentId = "BAN_6_CNT";
        //gridCells = this.createGridCells("grid-8");
        //this.section.title = null;
        break;
      case "layout-class-1":
        templateContentId = "BAN_7_CNT";
        //gridCells = this.createGridCells("grid-9");
        //this.section.title = null;
        break;
    
      default:
        templateContentId = "BAN_1_CNT";
        break;
    }
    this.editorTemplateService.getTemplate(templateContentId).subscribe(resp => {
      let section;
      let data = resp["data"];
      console.log(data)
      //Set the temporary ids
      section = this.setTemporaryIds(data["section"]);
      //Set the section Status;
      section.status = ContentStatusEnum.CTNT_IN_PROGRESS;
      //Set the status for each cell
      section = this.setCellContentStatus(section);
      //Set the placeholder images
      //section = this.setPlaceholderImages(section) 
      //Create the menu;
      this.gridCells = section.sectionData.bannerOptions.rowCells;
      //console.log(section.sectionData.layoutClass);
      //Convert the layoutClass to its value
      //section.sectionData.layoutClass = this.getLayoutClassValue(section.sectionData.layoutClass);
      //section.sectionData.layoutClass = GridLayoutEnum[section.sectionData.layoutClass];            
      console.log(this.section);
      this.selectedCell = this.gridCells[0]

      this.createMenu(this.gridCells);
      setTimeout(() => {
        this.hasLoaded = true;
        this.sectionBuilderStoreService.init(section)
      }, 100);
      
    })
    
    //this.section.sectionData.bannerOptions.rowCells = gridCells;
  }

  setTemporaryIds(section:Section):Section{
    section.sectionId = "temp-section-"+this.generateUniqueId();
    let gridCells:GridCell[] = section.sectionData.bannerOptions.rowCells;
    gridCells.forEach(gridCell => {
      gridCell.cellId = "temp-cell-"+this.generateUniqueId();
      let className:string = gridCell.className;
      gridCell.className = GridCellClass[className];
      let contentElements:ContentElement[] = gridCell.contentElements;
      contentElements.forEach(cntEl => {
        cntEl.elId = "temp-el-"+this.generateUniqueId();     
      })
    })
    return section
  }

  generateUniqueId() {
    const timestamp = Date.now(); // Get the current timestamp in milliseconds
    const randomNum = Math.floor(Math.random() * 1000000); // Generate a random number for extra uniqueness
    return `id-${timestamp}-${randomNum.toString(36)}`; // Combine timestamp and random number, convert to base-36
  }

  getLayoutClassValue(rawLayoutyClass){
    let layoutValue;
    if((rawLayoutyClass).includes(".")){
      let enumKey = rawLayoutyClass.split('.')[1] as keyof typeof GridLayoutEnum;
      layoutValue = GridLayoutEnum[enumKey];
    }else if(GridLayoutEnum[layoutValue] != undefined){
      layoutValue = ContentEnum[layoutValue]
    }else{
      layoutValue = layoutValue;
    }
    return layoutValue;
  }

  setCellContentStatus(section:Section):Section{
    let gridCells:GridCell[] = section.sectionData.bannerOptions.rowCells;
    gridCells.forEach(gridCell => {
      gridCell.status = ContentStatusEnum.CTNT_IN_PROGRESS;
    })
    return section
  }

  createMenu(gridCells:GridCell[]){
    //let menuItems:NbMenuItem = [];

    gridCells.forEach(cell => {
      let menuItemPlaceHolder:MenuItemPlaceHolder = {
        cellId: cell.cellId,
        item: null
      }
      let menuItem:NbMenuItem = {
        title:this.getMenuTitle(cell.contentEnum,"contentEnum"),
        children:this.getChildItems(cell)
      };
      menuItemPlaceHolder.item = menuItem;
      this.menuItemPlaceHolders.push(menuItemPlaceHolder);
      //this.menuItems.push(menuItem);
    })
    console.log(this.menuItems);
    //this.menuService.addItems(this.menuItems,"inputMenu");
  }

  getMenuTitle(titleEnum,enumType:string){
    let title;
    if(enumType === "contentEnum"){
      if((titleEnum).includes(".")){
        let enumKey = titleEnum.split('.')[1] as keyof typeof ContentEnum;
        title = ContentEnum[enumKey];
      }else if(ContentEnum[titleEnum] != undefined){
        title = ContentEnum[titleEnum]
      }else{
        title = titleEnum;
      }
    }else if(enumType === "contentElementEnum"){
      if(titleEnum != undefined){
        if((titleEnum).includes(".")){
          let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
          title = ContentElementEnum[enumKey];
        }else if(ContentElementEnum[titleEnum] != undefined){
          title = ContentElementEnum[titleEnum]
        }else{
          title = titleEnum;
        }
      }
      
    }
    
    return title;
  }
  getChildItems(gridCell:GridCell):NbMenuItem[]{
    let items:NbMenuItem[] = [];
    let layoutContext:MenuItemContext = {
      cellId:gridCell.cellId,
      cell:gridCell,
      target:"layout"
    }
    let layoutItem:NbMenuItem = {
      title: 'Cell Layout',
      data:layoutContext
    }
    items.push(layoutItem);
    items.push({title:"Content Elements",group:true});
    gridCell.contentElements.forEach(el => {
      if(!el.contentElementEnum){
        console.log("No contentElementEnum: "+el.name);
        switch (el.name) {
          case "Footer":
            el.contentElementEnum = ContentElementEnum.ACTION;
            break;
          case "Text":
            el.contentElementEnum = ContentElementEnum.TEXT;
            break;
          case "Badge":
            el.contentElementEnum = ContentElementEnum.SUB_HEADER;
            break;
        
          default:
            break;
        }
      }
      let item:NbMenuItem = {
        title: this.getMenuTitle(el.contentElementEnum,"contentElementEnum") || el.name?el.name:el.elId
      }
      let context:MenuItemContext = {};
      context.elId = el.elId;
      context.contentElement = el;
      context.cellId = gridCell.cellId;
      context.cell = gridCell;
      item.data = context;
      items.push(item);
    })
    return items
  }

  updateSection(e){
    console.log(e);
    this.section = e;
    if(this.section.status != undefined){
      this.status = this.section.status;
      this.addMenuItems(this.section,this.menuItemPlaceHolders);
      this.canSave = this.trackCellStatusses(this.section);
      console.log(this.menuItemPlaceHolders);
      this.status$.next(this.section.status);
    }
  }

  addMenuItems(section:Section,menuItemPlaceHolders:MenuItemPlaceHolder[]):void{
    let gridCells:GridCell[] = section.sectionData.bannerOptions.rowCells;
    gridCells.forEach(gridCell => {
      if(gridCell.status == "Initial Draft"){
        let placeHolderItem = menuItemPlaceHolders.find(item => item.cellId == gridCell.cellId);
        if(placeHolderItem != undefined){
          const idx = menuItemPlaceHolders.indexOf(placeHolderItem);
          const placeHolderMenuItems = menuItemPlaceHolders.splice(idx,1);
          if(placeHolderMenuItems){
            let nbMenuItems = [];
            nbMenuItems.push(placeHolderMenuItems[0].item);
            this.menuService.addItems(nbMenuItems,"inputMenu");
          }
        }
      }
    })
  }

  onSave(e){
    //1. Change the statusses of the section and each cell to final draft
    this.section.status = ContentStatusEnum.CTNT_FINAL_DRAFT;
    this.section.sectionData.bannerOptions.rowCells.forEach((cell:GridCell) => {
      cell.status = ContentStatusEnum.CTNT_FINAL_DRAFT;
    });
    this.previewEditStoreService.selectedPage$.subscribe(page => {
      console.log(page.pageName);
      if(this.section != undefined && this.section != null){
        page.sections.push(this.section);
        console.log(page.sections);
        this.previewEditStoreService.updateSelectedPage(page);
        this.previewEditStoreService.updatePageEditState(EditState.UPDATED);
        this.section = null;
      }
      //this.previewEditStoreService.updateEditState(EditState.EDITING);
      this.ref.close();
    })
    //2. Get the selected Page from the previewStore;
    //3. Add thgis section to the page;
    //4. Close the Input dialog
  }

  trackCellStatusses(section:Section):boolean{
    console.log(section.sectionData.bannerOptions.rowCells[0].status)
    let statusses = [];
    let canSave = false;
    let gridCells:GridCell[] = section.sectionData.bannerOptions.rowCells;
    gridCells.forEach(gridCell => {
      if(gridCell.status){
        statusses.push(gridCell.status);
      }
    })
    
    if(statusses.includes(ContentStatusEnum.CTNT_IN_PROGRESS)){
      canSave = false;
    }else if(statusses.includes(ContentStatusEnum.CTNT_INITIAL_DRAFT) && !statusses.includes(ContentStatusEnum.CTNT_IN_PROGRESS)){
      canSave = true
    }
    console.log(canSave);
    return canSave;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
